import React, { Component } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { imgStoragePath } from '../../constants';
import exportIcon from '../../shared/assets/img/export_icon.svg';
export default class ExportFiles extends Component{
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  toggleUpdate= (type)=> {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
    this.props.exportFile(type);
  }
  render() {
    const { files } = this.props;
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} style={this.props.style}>
        <DropdownToggle
          tag="button"
          onClick={this.toggle}
          data-toggle="dropdown"
          aria-expanded={this.state.dropdownOpen}
          className="export-dropdown"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            border: '1px solid rgba(25, 118, 210, 0.5)',
            borderRadius: '4px',
            background: 'transparent',
            color: '#1976d2',
            fontWeight: '500',
            fontSize: '0.8125rem',
            padding: '3px 9px',
            cursor: 'pointer',
            letterSpacing: '0.02857em',
            textTransform: 'uppercase',
            lineHeight: '1.75',
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            transition: 'border-color 250ms cubic-bezier(0.4,0,0.2,1), background-color 250ms cubic-bezier(0.4,0,0.2,1)',
            boxShadow: 'none',
          }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(25,118,210,0.04)'; e.currentTarget.style.borderColor = '#1976d2'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderColor = 'rgba(25,118,210,0.5)'; }}
        >
          <img className="export-icn" src={exportIcon} alt="Export" style={{ width: '18px', height: '18px' }} />
          {this.props.exportName ? this.props.exportName : 'EXPORT'}
        </DropdownToggle>
        <DropdownMenu className="export-dropdown-menu">
          { files.map((file,index) =>
            <div className="menu-item flex-centered" key={index} onClick={() => {this.toggleUpdate(file.type)}}><img src={imgStoragePath + file.img} /> {file.label}</div>
          )}
        </DropdownMenu>
      </Dropdown>
    );
  }
}
